<div class="input-form">
    <h5>Title</h5>
    <div>
        <input name="ruleTitle" type="text"
            [(ngModel)]="newRule.title"
            (change)="newRule.title = newRule.title.trim()" >
    </div>
    <h5>Description</h5>
    <div>
        <textarea name="ruleDescription" rows="4"
            [(ngModel)]="newRule.description"
            (change)="newRule.description = newRule.description.trim()"></textarea>
    </div>
    <div class="field-section">
        <h5>Status</h5>
        <div>
            <cv-dropdown class="d-inline-block mr-1"
                [placeholder]="'Select Type'"
                [optionText]="'name'"
                [selectedValue]="{ name: ruleMessageType.Info }"
                [options]="[{ name: ruleMessageType.Info}, { name: ruleMessageType.Warning}, { name: ruleMessageType.Error}]"
                (valuesChange)="onSelectRuleMessageType($event)">
            </cv-dropdown>
        </div>
    </div>
    <div class="text-right">
        <button class="btn btn-sm btn-submit btn-secondary"
                [disabled]="processing ||
                            newRule.title === '' ||
                            newRule.description === '' ||
                            newRule.messageType === null"
                (click)="onCreateNewRule()">
            Post
            <div *ngIf="processing" class="loading-wrapper">
                <i class="fas fa-spinner"></i>
            </div>
        </button>
    </div>
</div>